import { IService, LocalizedService, MaintenanceMenu, RNDService } from '../API/GoMoto';
import { SpgPricingType } from '../API/Enums';

export const rndMinEstCost = (rnd: RNDService) => {
    if (rnd.price !== null && rnd.price !== undefined) {
        return rnd.price;
    }
    else if (rnd.linkedService) {
        if (rnd.linkedService.useSpgPricing) {
            return minEstCost(rnd.linkedService);
        }
        else {
            return rnd.linkedService.price;
        }
    }

    return null;
};

/**
 * Returns the minimum price of a service, or null if non-existent
 * @param service A `LocalizedService` or `MaintenanceMenu`
 */
export const minEstCost = (service: LocalizedService | MaintenanceMenu | IService | { useSpgPricing: boolean; price: number; }): number | null => {
    // non-SPG-priced service
    if (('useSpgPricing' in service && !service.useSpgPricing) || ('isSpgOp' in service && !service.isSpgOp)) {
        // For non-SPG-priced services, we don't want "Ask Me About Pricing" to show
        return service.price ?? 0;
    }
    else if ('spgPricing' in service) {
        switch (service.spgPricing) {
            case SpgPricingType.NoPrice:
                return null;
            case SpgPricingType.Range:
            case SpgPricingType.Minimum:
                return service.priceLow ?? ('price' in service ? service.price : null) ?? null;
            case SpgPricingType.Maximum:
                return service.priceHigh ?? ('price' in service ? service.price : null) ?? null;
        }
    }

    return null;
};
